import { fulfillmentApi } from '../../../api/fulfillmentApi';
import { AppDispatch, RootState } from '../../store';
import { setTransactions, startLoadingTransactions } from './transactionsSlice';

export const getTransactions = () => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingTransactions());
        let transaction = {};
        const resp = await fulfillmentApi.get(`transactions/`);
        transaction = resp.data;

        dispatch(setTransactions({ transactions: transaction }));
    }
}
